/* eslint-disable max-len */
import { h } from 'preact';
import { useMemo } from 'preact/hooks';
import { days as originalDays } from '../utils/helpers';

const StoreHours = ({ location, locationStatus, ...props }) => {

  const { hours } = location;
  const d = new Date();
  const currentDay = d.getDay();

  // Week should start on Monday [LC-703]
  const days = useMemo(() => {
    const daysOfTheWeek = [...originalDays];
    daysOfTheWeek.push(daysOfTheWeek.shift());
    return daysOfTheWeek;
  }, [originalDays]);
  const getActualIndex = (a) => (a >= 6 ? 0 : a + 1);

  return (
    <div {...props}>
      <ul
        className="[&_*]:body-3"
        aria-label={window.TMW.Strings.storeLocator.workingHours}
      >
        {days.map((day, index) => (
          <li
            key={day}
            className={`flex justify-between gap-2 items-center ${currentDay === getActualIndex(index) &&
              (locationStatus.openNow === true ? 'text-misc-green' :
                locationStatus.openNow === false ? 'text-error' : '')
              }`}
          >
            <span className={`${currentDay === getActualIndex(index) ? '!font-semibold' : ' '}`}>{day}</span>
            {currentDay === getActualIndex(index) ? (
              <span className={`text-right`}>
                {locationStatus.openToday &&
                  locationStatus.openNow &&
                  `${window.TMW.Strings.storeLocator.open} `}
                {locationStatus.openToday &&
                  !locationStatus.openNow &&
                  `${window.TMW.Strings.storeLocator.closed} `}
                <span className="pl-2 inline-block break-all">
                  {hours && hours[getActualIndex(index)]?.displayHours}
                </span>
              </span>
            ) : (
              <span className={`text-right`}>
                {hours && hours[getActualIndex(index)]?.displayHours}
              </span>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default StoreHours;
